module.exports = __webpack_public_path__ + "img/av196.211b8023.png";